<div class="modal-header bg-primary text-white">
    <h4 class="modal-title pull-left">Memo</h4>
    <button pRipple type="button" class="btn-close" aria-label="btn-close" (click)="close()">
  </button>
    <!--<a href="javascript:void(0)" class="btn-close me-2" (click)="maximize()">
        <i class="fas fa-window-maximize text-white" *ngIf="!isMaximized"></i>
        <i class="fas fa-window-minimize text-white" *ngIf="isMaximized"></i>
    </a>-->
</div>
<div class="modal-body">
    <app-memo [facilityId]="facilityId" [facilityDateCreated]="facilityDateCreated"  [vfcPin]="vfcPin"></app-memo>
</div>